"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exporterAPI = exports.getClientGoalExportLimit = exports.exportCSV = exports.askForExportCSV = void 0;
const createApi_1 = require("../../helpers/createApi");
const askForExportCSV = (caller) => ({ clientId, campaignId, exportType }) => caller(`/v1/clients/${clientId}/campaigns/${campaignId}/exports/${exportType}`).post();
exports.askForExportCSV = askForExportCSV;
const exportCSV = (caller) => ({ clientId, campaignId, exportType, filters, excludeFilters, startDate, endDate, intervals, goalName }) => caller(`/v2/clients/${clientId}/export`).post({
    campaign_id: campaignId,
    kind: exportType,
    startDate,
    endDate,
    intervals,
    filters,
    exclude_filters: excludeFilters,
    goal_name: goalName,
});
exports.exportCSV = exportCSV;
const getClientGoalExportLimit = (caller) => ({ clientId, campaignId, exportType, goalName }) => caller(`/v2/clients/${clientId}/limit`).post({
    campaign_id: campaignId,
    kind: exportType,
    goal_name: goalName,
});
exports.getClientGoalExportLimit = getClientGoalExportLimit;
exports.exporterAPI = (0, createApi_1.createAPIFactory)({
    askForExportCSV: exports.askForExportCSV,
    exportCSV: exports.exportCSV,
    getClientGoalExportLimit: exports.getClientGoalExportLimit,
});
//# sourceMappingURL=api.js.map